// Define the Intercom function type
type IntercomFunction = {
  (command: string, ...args: any[]): void;
  q?: any[];
  c?: (args: IArguments | any[]) => void;
  visible?: boolean;
};

// Extend the Window interface
declare global {
  interface Window {
    Intercom: IntercomFunction;
  }
}

// This is the "shell" Intercom object, which the Intercom script will look at once it's loaded
window.Intercom = function (...args: any[]) {
  window.Intercom.c?.(args);
} as IntercomFunction;
window.Intercom.q = [];
window.Intercom.c = (args: IArguments | any[]) => window.Intercom.q!.push(args);

// Intercom settings type (customize as needed)
type IntercomSettings = {
  app_id: string;
  [key: string]: any;
};

// We defer for a few seconds after page load as we want the page load itself to be snappy
export function bootIntercomDeferred(settings: IntercomSettings, delayMs = 1000) {
  window.Intercom("update", settings);

  setTimeout(() => {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${settings.app_id}`;
    const x = document.getElementsByTagName("script")[0];
    x.parentNode!.insertBefore(s, x);
  }, delayMs);
}

// Because the window.Intercom Object changes after the actual script is loaded we use this wrapper
// which enables other files to import it as though it were a static object
export function Intercom(...args: any[]) {
  // @ts-expect-error - TS doesn't like calling a function typed object
  window.Intercom.call(null, ...args);
}

// Add the 'visible' property to the Intercom function object
Intercom.visible = false;

// it's handy to track the visible state
// eslint-disable-next-line no-undef
Intercom("onShow", () => (Intercom.visible = true));
// eslint-disable-next-line no-undef
Intercom("onHide", () => (Intercom.visible = false));
